export enum ItpButtonType {
  Primary = 'itpBtnPrimary',
  RedOutline = 'itpBtnRedOutline',
  BlackOutline = 'itpBtnBlackOutline',
  Warning = 'itpBtnWarning',
}
